import { Component, OnInit } from '@angular/core';

import { DialogRef } from '@ngneat/dialog';

import { GmapsMap, GmapsPosition } from '../../models/gmaps.model';

@Component({
  selector: 'bkg-gmaps-dialog',
  templateUrl: './gmaps-dialog.component.html',
})
export class GmapsDialogComponent implements OnInit {
  gmapConfig: GmapsMap;
  gmapsLink: string;

  constructor(public ref: DialogRef) {}

  ngOnInit(): void {
    this.gmapConfig = this.ref.data as GmapsMap;
    const position = this.convertLatLng(this.gmapConfig.markers[0].position);
    this.gmapsLink =
      'https://www.google.com/maps?q=' +
      position.lat.toString() +
      ',' +
      position.lng.toString();
  }

  onClickClose(): void {
    this.ref.close();
  }

  private convertLatLng(position: GmapsPosition): GmapsPosition {
    return {
      lat: Number(position.lat),
      lng: Number(position.lng),
    };
  }
}
